<script setup lang="ts">
import { DialogModal } from '@metapic-apps/shared'

import type { AdvertiserType } from '@/lib/types/advertiser.types'
import { BoxComponent, ButtonComponent, FlexComponent, ImageComponent, TypographyComponent } from '@/ui-library'

defineProps<{
  advertisers: AdvertiserType[]
}>()
const isOpen = defineModel<boolean>('modelValue', { default: false })
const selectedAdvertiser = defineModel<AdvertiserType>('selectedAdvertiser')
</script>
<template>
  <DialogModal v-model="isOpen" :show-close="false">
    <template #header>
      <TypographyComponent variant="headline-medium">Select advertiser</TypographyComponent>
    </template>

    <template #default>
      <BoxComponent :mt="24" :mb="24">
        <TypographyComponent variant="body-large">
          There are several advertisers connected to your link domain. Please select your desired advertiser:
        </TypographyComponent>
      </BoxComponent>
      <BoxComponent>
        <FlexComponent align="center" :gap="8" wrap="wrap">
          <label
            v-for="(item, index) in advertisers"
            :key="item.id"
            :for="index.toString()"
            :class="['advertiser-selector__button', { selected: item.id === selectedAdvertiser?.id }]"
          >
            <input :id="index.toString()" v-model="selectedAdvertiser" :value="item" type="radio" />
            <ImageComponent v-if="item.logo" :image="item.logo" :alt="item.name" :height="24" :width="67" object-fit="contain" skip-width />
            <TypographyComponent variant="label-large" text-truncate>{{ item.name }}</TypographyComponent>
          </label>
        </FlexComponent>
      </BoxComponent>
      <BoxComponent :mt="32">
        <FlexComponent :gap="8" justify="flex-end">
          <ButtonComponent variant="primary" :is-disabled="!selectedAdvertiser" @click="isOpen = false"> Select </ButtonComponent>
        </FlexComponent>
      </BoxComponent>
    </template>
  </DialogModal>
</template>
<style lang="scss" scoped>
.advertiser-selector__button {
  border-radius: 8px;
  padding: 16px;
  border: 1px solid rgba(34, 34, 34, 0.12);
  display: flex;
  width: calc(50% - 4px);
  align-items: center;
  gap: 16px;
  cursor: pointer;

  input[type='radio'] {
    display: none;
  }

  &.selected {
    border-color: #222;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>
